import { View, Text, StyleSheet, TouchableOpacity, ScrollView, Button, Image, Platform, Modal, ActivityIndicator, PixelRatio, Dimensions } from 'react-native'
import React, { useEffect, useState } from 'react'
import { useRoute } from '@react-navigation/native'
import { TextInput } from 'react-native'
import Colours from '../../utils/Colours'
import axios from '../../api/axios'
import { useNavigation } from '@react-navigation/native'
import { useQuery } from '@tanstack/react-query'
import LocationIcon from '../../icons/LocationIcon'
import nigeriaStatesAndCities from '../../datas/NigerianStatesAndCities'
import ErrorAlertComp from '../../alertComp/ErrorAlertComp'
import BackArrow from '../../icons/BackArrow'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import SuccessAlertComp from '../../alertComp/SuccessAlertComp'
import AppTextInput from '../../utils/ColourThemes/AppTextInput'



const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const MyCityState = ({ fromSettings, setShowMyCityState, fromHomePage, setReloadCityImageData }) => {

    const [isStateFormFocused, setIsStateFormFocused] = useState(false)
    const [isStateValid, setIsStateValid] = useState(false)
    const [isLoadingSearch, setIsLoadingSearch] = useState(false)
    // const [buttonActive, setButtonActive] = useState(true)
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessage2, setErrorMessage2] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const [isLoadingUpdate, setIsLoadingUpdate] = useState(false)
    const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false)

    const [selectedTags, setSelectedTags] = useState(null);
    const [searchState, setSearchState] = useState('');
    const [cityState, setCityState] = useState('')
    const [isErrorCompVisible, setIsErrorCompVisible] = useState('')
    const [cities, setCities] = useState([]);

    const route = useRoute();

    const userDataObj_v2 = fromSettings ? "" : route.params.userDataObj_v2;
    // const image = userDataObj.image;
    //console.log('userDataObj_v2', userDataObj_v2)

    const navigate = useNavigation()

    const axiosPrivate = useAxiosPrivate()

    const handleSearch = (input) => {
        setSearchState(input);

        let foundCities = [];
        let cityState = ''
        Object.values(nigeriaStatesAndCities).forEach(region => {
            Object.values(region).forEach(states => {
                Object.keys(states).forEach(state => {
                    if (state.toLowerCase() === input.toLowerCase()) {
                        foundCities = states[state];
                        cityState = state
                    }
                });
            });
        });

        setCities(foundCities);
        setCityState(cityState)
    };
    //UpdateProfilePage

    const handleTagSelection = (tag) => {
        //console.log('tag', tag)
        //console.log('city', cities)
        //console.log('cityState', cityState)
        setSelectedTags(tag);
    }

    const handleUserLocation = () => {

        if (searchState === '') {
            setIsStateFormFocused(true)
        } else if (selectedTags === null) {
            setErrorMessage2('Please choose your city or any other city on the list if you cannot find yours. Make sure you have entered a state and not a capital')
            setIsErrorCompVisible(true)
        } else {
            const city = selectedTags
            const cityStateObj = { cityState, city }
            // setNamesObjData(namesObj)
            const userDataObj_v3 = { ...userDataObj_v2, ...cityStateObj }
            //console.log("cityStateObj", cityStateObj)
            navigate.push('setProfileBio', { userDataObj_v3 })
        }





    }

    const handleUserChangeLocation = async () => {
        if (searchState === '') {
            setIsStateFormFocused(true)
        } else if (selectedTags === null) {
            setErrorMessage2('Please choose your city or any other city on the list if you cannot find yours. Make sure you have entered a state and not a capital')
            setIsErrorCompVisible(true)
        } else {
            const city = selectedTags
            // const cityStateObj = { cityState, city }
            try {

                setIsLoadingUpdate(true)

                const response = await axiosPrivate.post('/changeCityState/changeCityState', { state: cityState, city })



                if (response.status === 200 || response.status === 201) {
                    setSuccessMessage(response.data.message)
                    setIsSuccessCompVisible(true)
                } else {
                    setErrorMessage('Error updating your location')
                    setIsErrorCompVisible(true)
                }

            } catch (error) {
                setErrorMessage(error.response.data.message)
                setIsErrorCompVisible(true)
            } finally {
                setIsLoadingUpdate(false)
            }
        }
    }


    return (
        <ScrollView contentContainerStyle={{ flexGrow: 1, paddingBottom: dynamicSpacing(100), backgroundColor: 'white' }}>
            <View style={styles.createPullFormContainer}>
                {fromSettings ? (null) : (<TouchableOpacity
                    // onPress={() => navigate.push('username_displayname')}
                    onPress={() => navigate.goBack()}

                >
                    <BackArrow color={Colours.DARKGRAY} />
                </TouchableOpacity>)}
                <View style={styles.profilePhotoContainer} >
                    <LocationIcon color={Colours.PRIMARY} height={dynamicSize(30)} width={dynamicSize(30)} />
                    <Text style={{ color: Colours.DARKGRAY, fontSize: dynamicFontSize(30), fontFamily: 'Sen-Regular' }}>
                        {/* {fromSettings ? 'My New Location' : 'My Location'} */}
                        {fromSettings ? 'My Location' : 'My Location'}
                    </Text>
                    <Text style={{
                        color: Colours.DARKGRAY, fontSize: dynamicFontSize(13), fontFamily: 'Sen-Regular',
                        textAlign: 'center', width: dynamicSize(200), marginTop: dynamicSpacing(10)
                    }}>
                        This information is private and seen by only you, it will be helpful to improve our Algorithm and serve you better.
                    </Text>
                </View>
                <View style={styles.textAndTxtInput}>
                    {/* <Text style={{ color: Colours.DARKGRAY, fontSize: dynamicFontSize(12), fontFamily: 'Sen-Regular' }}>
                    STATE
                </Text> */}
                    <AppTextInput style={[styles.textInputStyle, isStateFormFocused && styles.focusedBorder,]}
                        placeholder='Enter your state'
                        fontSize={dynamicSize(15)}
                        // keyboardType="email-address"
                        //autoCapitalize='none'
                        value={searchState}
                        onFocus={() => setIsStateFormFocused(true)}
                        onBlur={() => setIsStateFormFocused(false)}
                        onChangeText={handleSearch}

                    />{isLoadingSearch ? (

                        <View style={{ display: 'flex', height: dynamicSize(20), justifyContent: 'center', alignItems: 'center' }}>
                            <ActivityIndicator size={'small'} />
                        </View>
                    ) : (
                        !isStateValid && <Text style={{ color: 'red' }}>{errorMessage}</Text>
                    )}
                    {cities.length > 0 ? (<>
                        <View style={styles.pickCity}>
                            <Text style={{
                                color: Colours.PRIMARY, fontSize: dynamicFontSize(13), fontFamily: 'Sen-Regular', marginTop: dynamicSpacing(10)
                            }}>
                                Pick your city to continue
                            </Text>
                        </View>

                        <View style={styles.tagsViewStyle}>

                            {cities.map((tag) => (
                                <TouchableOpacity
                                    key={tag}
                                    style={{
                                        backgroundColor: selectedTags === tag ? Colours.PRIMARY : 'white',
                                        borderRadius: dynamicSize(20),
                                        padding: dynamicSpacing(7),
                                        margin: dynamicSpacing(3),
                                    }}
                                    onPress={() => handleTagSelection(tag)}
                                >
                                    <Text style={{ fontFamily: 'Sen-Regular', color: selectedTags === tag ? 'white' : Colours.DARKGRAY }}>{tag}</Text>
                                </TouchableOpacity>
                            ))}
                        </View>
                    </>) : ("")
                    }
                </View>

                <TouchableOpacity style={styles.buttonGray}
                    onPress={fromSettings ? handleUserChangeLocation : handleUserLocation}
                // disabled={buttonActive}
                >
                    {isLoadingUpdate ? (
                        <ActivityIndicator color='white' size={'small'} />
                    ) : (
                        <Text style={{ color: 'white', fontSize: dynamicFontSize(15), fontFamily: 'Sen-Bold' }}>{fromSettings ? 'UPDATE' : 'NEXT'}</Text>
                    )}
                </TouchableOpacity>



                <Modal
                    visible={isErrorCompVisible}
                    transparent={true}
                    animationType="fade"
                >
                    <ErrorAlertComp
                        message={errorMessage2}
                        onClose={() => setIsErrorCompVisible(false)}
                    />
                </Modal>

                <Modal
                    visible={isSuccessCompVisible}
                    transparent={true}
                    animationType="fade"
                >
                    <SuccessAlertComp
                        message={successMessage}
                        onClose={() => {

                            setIsSuccessCompVisible(false)
                            fromSettings ? setShowMyCityState(false) : null
                            fromHomePage ? setReloadCityImageData(true) : null
                        }}
                    />
                </Modal>
            </View>
        </ScrollView>
    )
}

const styles = StyleSheet.create({
    createPullFormContainer: {
        flex: 1, // Use flex: 1 to fill the screen
        paddingTop: dynamicSpacing(100),
        padding: dynamicSpacing(15),
        backgroundColor: 'white',
    },
    textAndTxtInputRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: dynamicSpacing(15),
    },
    textAndTxtInput: {
        marginTop: dynamicSpacing(15),
    },
    textInputStyle: {
        height: dynamicSpacing(50),
        marginTop: dynamicSpacing(10),
        padding: dynamicSpacing(15),
        borderWidth: dynamicSize(1.5),
        borderColor: Colours.DARKLIGHTGRAY,
        borderRadius: dynamicSize(7),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(12),
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
    },
    buttonGray: {
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: dynamicSize(15),
        marginTop: dynamicSpacing(25),
        height: dynamicSpacing(60),
        backgroundColor: Colours.PRIMARY
    },
    profilePhotoContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: dynamicSpacing(10),
    },
    pickCity: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    userImage: {
        width: dynamicSize(100),
        height: dynamicSize(100),
        borderRadius: dynamicSize(99),
        marginBottom: dynamicSpacing(3),
        borderWidth: dynamicSize(1.5),
        borderColor: Colours.PRIMARY,
        marginTop: dynamicSpacing(10),
        backgroundColor: Colours.LIGHTGRAY,
    },
    tagsViewStyle: {
        // flex: 1,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginTop: dynamicSpacing(10),
        marginBottom: dynamicSpacing(5),
        padding: dynamicSpacing(10),
        borderWidth: dynamicSize(3),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(15),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(17),
        backgroundColor: Colours.LIGHTGRAY,
    },
});

export default MyCityState

